var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckemaillightIconSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "CheckEmailLight icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76,23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 35,
    r: 46,
    fill: "#16a34a",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 76,
    height: 54,
    rx: 9,
    fill: "none",
    stroke: "#16a34a",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14 L44 40 L79 14",
    fill: "none",
    stroke: "#16a34a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76,85)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 35,
    r: 46,
    fill: "#f59e0b",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 76,
    height: 54,
    rx: 9,
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14 L44 40 L79 14",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76,147)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 35,
    r: 46,
    fill: "#dc2626",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 76,
    height: 54,
    rx: 9,
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14 L44 40 L79 14",
    fill: "none",
    stroke: "#dc2626",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckemaillightIconSquare);
export default __webpack_public_path__ + "static/media/checkemaillight-icon-square.5a2472b09b27780dcfb62740e11ded04.svg";
export { ForwardRef as ReactComponent };